import { useTranslation } from 'react-i18next'
import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Pop the current screen out into its own tab or window.
 *
 * For a person at a desk who wants a recovery on a second monitor. It carries the signed-in
 * user's own session, so it locks and signs out exactly like any other tab — it is NOT a
 * display, and deliberately grants nothing.
 *
 * A wall screen in the command-and-control centre is the other thing: enrolled at /display,
 * read-only, and exempt from the lock. Both exist because they are different needs; only the
 * second one is a credential.
 */
export function OpenInNewTab({
    path, title, variant = 'outline',
}: { path?: string; title?: string; variant?: 'outline' | 'ghost' }) {
    const { t } = useTranslation()
    const target = path || `${window.location.pathname}${window.location.search}`

    return (
        <Button
            size="sm"
            variant={variant}
            className="gap-1.5"
            title={title || t('common.openInNewTabHelp', 'Open this screen in a new tab — useful on a second monitor')}
            onClick={() => window.open(target, '_blank', 'noopener,noreferrer')}
        >
            <ExternalLink className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{t('common.openInNewTab', 'Open in new tab')}</span>
        </Button>
    )
}
